/* eslint-disable max-len */
/* eslint-disable prettier/prettier */

/**
 * This file can be used for unit tests.
 */
import {
  CurriculumProgressDTO,
  LessonProgressType,
} from '@peartherapeutics/hylia-api-client';

export const curriculumProgressInitialState: CurriculumProgressDTO = {
  totalLessonsCompleted: 62,
  totalLessonsCompletedThisRx: 5,
  totalLessonsCompletedThisWeek: 1,
  hasMultipleRx: true,
  lessonGroups: [
    {
      lessonsCompleted: 26,
      name: 'Core Lessons',
      id: 'core',
      lessons: [
        {
          completionDates: [
            '2022-12-14T01:47:46.893Z',
            '2022-09-19T09:23:00.000Z',
            '2022-12-07T07:00:00.000Z',
            '2022-09-25T12:00:00.000Z',
            '2022-12-07T03:00:00.000Z',
          ],
          hasProficiency: true,
          lastCompletionDate: '2022-12-14T01:47:46.893Z',
          lastUsageDate: '2022-12-07T07:00:00.000Z',
          id: 'understanding-my-substance-use-patterns',
          name: 'Understanding My Substance Use Patterns',
          totalTimeSpentMins: 19,
          type: LessonProgressType.Revisited,
          usageDates: [
            '2022-12-07T04:00:00.000Z',
            '2022-12-07T03:00:00.000Z',
            '2022-09-25T12:00:00.000Z',
            '2022-09-19T09:23:00.000Z',
            '2022-12-07T07:00:00.000Z',
          ],
        },
        {
          completionDates: [
            '2022-09-19T09:23:00.000Z',
            '2022-12-07T08:00:00.000Z',
            '2022-09-25T12:00:00.000Z',
            '2022-12-07T03:00:00.000Z',
          ],
          hasProficiency: true,
          lastCompletionDate: '2022-12-07T08:00:00.000Z',
          lastUsageDate: '2022-12-07T08:00:00.000Z',
          id: 'ready-to-make-your-map',
          name: 'Ready to Make Your Map?',
          totalTimeSpentMins: 14,
          type: LessonProgressType.Revisited,
          usageDates: [
            '2022-12-07T03:00:00.000Z',
            '2022-09-25T12:00:00.000Z',
            '2022-12-07T08:00:00.000Z',
          ],
        },
        {
          completionDates: [
            '2022-09-19T09:23:00.000Z',
            '2022-09-26T12:00:00.000Z',
            '2022-12-07T03:00:00.000Z',
          ],
          hasProficiency: true,
          lastCompletionDate: '2022-12-07T03:00:00.000Z',
          lastUsageDate: '2022-12-07T03:00:00.000Z',
          id: 'risk-management',
          name: 'Risk Management',
          totalTimeSpentMins: 11.333333333333334,
          type: LessonProgressType.Revisited,
          usageDates: ['2022-12-07T03:00:00.000Z', '2022-09-26T12:00:00.000Z'],
        },
        {
          completionDates: [
            '2022-12-07T03:00:00.000Z',
            '2022-09-27T12:00:00.000Z',
            '2022-09-19T09:23:00.000Z',
          ],
          hasProficiency: true,
          lastCompletionDate: '2022-12-07T03:00:00.000Z',
          lastUsageDate: '2022-12-07T03:00:00.000Z',
          id: 'introduction-to-problem-solving',
          name: 'Introduction to Problem Solving',
          totalTimeSpentMins: 14,
          type: LessonProgressType.Revisited,
          usageDates: ['2022-12-07T03:00:00.000Z', '2022-09-27T12:00:00.000Z'],
        },
        {
          hasProficiency: false,
          id: 'problem-solving-in-action',
          name: 'Problem Solving In Action',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/problem-solving-in-action/worksheets/problem-solving-in-action.pdf',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          completionDates: [
            '2022-10-04T03:00:00.000Z',
            '2022-12-07T03:00:00.000Z',
          ],
          hasProficiency: true,
          lastCompletionDate: '2022-12-07T03:00:00.000Z',
          lastUsageDate: '2022-10-04T03:00:00.000Z',
          id: 'refusal-skills-training',
          name: 'Refusal Skills Training',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Revisited,
          usageDates: ['2022-10-04T03:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-04T03:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-04T03:00:00.000Z',
          lastUsageDate: '2022-10-04T03:00:00.000Z',
          id: 'seemingly-unimportant-decisions',
          name: 'Seemingly Unimportant Decisions',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/seemingly-unimportant-decisions/worksheets/seemingly-unimportant-decisions.pdf',
          totalTimeSpentMins: 2,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-04T03:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-04T03:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-04T03:00:00.000Z',
          lastUsageDate: '2022-10-04T03:00:00.000Z',
          id: 'identifying-thoughts-about-using',
          name: 'Identifying Thoughts About Using',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-04T03:00:00.000Z'],
        },
        {
          hasProficiency: false,
          id: 'coping-with-thoughts-about-using',
          name: 'Coping With Thoughts About Using',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/coping-with-thoughts-about-using/worksheets/coping-with-thoughts-about-using.pdf',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          completionDates: ['2022-10-06T03:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-06T03:00:00.000Z',
          lastUsageDate: '2022-10-06T03:00:00.000Z',
          id: 'unhelpful-thinking-part-1-thoughts-feelings-and-actions',
          name: 'Unhelpful Thinking Part 1: Thoughts, Feelings, and Actions',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/unhelpful-thinking-part-1-thoughts-feelings-and-actions/worksheets/unhelpful-thinking-part-1-thoughts-feelings-and-actions.pdf',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-06T03:00:00.000Z'],
        },
        {
          hasProficiency: false,
          id: 'unhelpful-thinking-part-2-catch-it-challenge-it-change-it',
          name: 'Unhelpful Thinking Part 2: Catch It, Challenge It, Change It',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/unhelpful-thinking-part-2-catch-it-challenge-it-change-it/worksheets/unhelpful-thinking-part-2-catch-it-challenge-it-change-it.pdf',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          completionDates: ['2022-10-14T03:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-14T03:00:00.000Z',
          lastUsageDate: '2022-10-14T03:00:00.000Z',
          id: 'unhelpful-thinking-part-3-challenge-it-strategies',
          name: 'Unhelpful Thinking Part 3: "Challenge It" Strategies',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-14T03:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-14T03:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-14T03:00:00.000Z',
          lastUsageDate: '2022-10-14T03:00:00.000Z',
          id: 'sodas-decision-tool',
          name: 'SODAS Decision Tool',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-14T03:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-15T03:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-15T03:00:00.000Z',
          lastUsageDate: '2022-10-15T03:00:00.000Z',
          id: 'building-healthy-habits',
          name: 'Building Healthy Habits',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-15T03:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-15T09:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-15T09:00:00.000Z',
          lastUsageDate: '2022-10-15T09:00:00.000Z',
          id: 'assertiveness',
          name: 'Assertiveness',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/assertiveness/worksheets/assertiveness.pdf',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-15T09:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-19T09:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-19T09:00:00.000Z',
          lastUsageDate: '2022-10-19T09:00:00.000Z',
          id: 'being-assertive',
          name: 'Being Assertive',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/being-assertive/worksheets/being-assertive.pdf',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-19T09:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-19T09:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-19T09:00:00.000Z',
          lastUsageDate: '2022-10-19T09:00:00.000Z',
          id: 'constructive-feedback',
          name: 'Constructive Feedback',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/constructive-feedback/worksheets/constructive-feedback.pdf',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-19T09:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-19T09:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-19T09:00:00.000Z',
          lastUsageDate: '2022-10-19T09:00:00.000Z',
          id: 'giving-constructive-feedback',
          name: 'Giving Constructive Feedback',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-19T09:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-19T09:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-19T09:00:00.000Z',
          lastUsageDate: '2022-10-19T09:00:00.000Z',
          id: 'receiving-feedback',
          name: 'Receiving Feedback',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-19T09:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-19T09:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-19T09:00:00.000Z',
          lastUsageDate: '2022-10-19T09:00:00.000Z',
          id: 'compliments',
          name: 'Compliments',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-19T09:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-27T09:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-27T09:00:00.000Z',
          lastUsageDate: '2022-10-27T09:00:00.000Z',
          id: 'substance-use-feelings-and-communication',
          name: 'Substance Use, Feelings, and Communication',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-27T09:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-28T09:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-28T09:00:00.000Z',
          lastUsageDate: '2022-10-28T09:00:00.000Z',
          id: 'nonverbal-communication',
          name: 'Nonverbal Communication',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/nonverbal-communication/worksheets/nonverbal-communication.pdf',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-28T09:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-28T09:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-28T09:00:00.000Z',
          lastUsageDate: '2022-10-28T09:00:00.000Z',
          id: 'inviting-joy',
          name: 'Inviting Joy',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/inviting-joy/worksheets/inviting-joy.pdf',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-28T09:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-28T09:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-28T09:00:00.000Z',
          lastUsageDate: '2022-10-28T09:00:00.000Z',
          id: 'attentive-listening',
          name: 'Attentive Listening',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-28T09:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-28T09:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-28T09:00:00.000Z',
          lastUsageDate: '2022-10-28T09:00:00.000Z',
          id: 'sharing-feelings',
          name: 'Sharing Feelings',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-28T09:00:00.000Z'],
        },
        {
          completionDates: ['2022-10-28T09:00:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-10-28T09:00:00.000Z',
          lastUsageDate: '2022-10-28T09:00:00.000Z',
          id: 'hiv-and-aids',
          name: 'HIV and AIDS',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-10-28T09:00:00.000Z'],
        },
        {
          completionDates: ['2022-11-03T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-03T09:23:00.000Z',
          lastUsageDate: '2022-11-03T09:23:00.000Z',
          id: 'sexually-transmitted-infections-stis',
          name: 'Sexually Transmitted Infections (STIs)',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-03T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-04T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-04T09:23:00.000Z',
          lastUsageDate: '2022-11-04T09:23:00.000Z',
          id: 'preventing-stis-and-hiv',
          name: 'Preventing STIs and HIV',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-04T09:23:00.000Z'],
        },
        {
          hasProficiency: false,
          id: 'drug-use-hiv-and-hepatitis',
          name: 'Drug Use, HIV, and Hepatitis',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          hasProficiency: false,
          id: 'identifying-triggers-for-risky-sex',
          name: 'Identifying Triggers For Risky Sex',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          completionDates: ['2022-11-04T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-04T09:23:00.000Z',
          lastUsageDate: '2022-11-04T09:23:00.000Z',
          id: 'keeping-focus-on-recovery',
          name: 'Keeping Focus on Recovery',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-04T09:23:00.000Z'],
        },
      ],
      lessonsUseByDate: [
        {
          date: 1663560000000,
          totalTimeSpentMins: 4,
        },
        {
          date: 1664078400000,
          totalTimeSpentMins: 7,
        },
        {
          date: 1664164800000,
          totalTimeSpentMins: 2,
        },
        {
          date: 1664251200000,
          totalTimeSpentMins: 6,
        },
        {
          date: 1664769600000,
          totalTimeSpentMins: 9,
        },
        {
          date: 1664942400000,
          totalTimeSpentMins: 3,
        },
        {
          date: 1665633600000,
          totalTimeSpentMins: 7,
        },
        {
          date: 1665720000000,
          totalTimeSpentMins: 4,
        },
        {
          date: 1665806400000,
          totalTimeSpentMins: 4,
        },
        {
          date: 1666152000000,
          totalTimeSpentMins: 15,
        },
        {
          date: 1666843200000,
          totalTimeSpentMins: 3,
        },
        {
          date: 1666929600000,
          totalTimeSpentMins: 19,
        },
        {
          date: 1667448000000,
          totalTimeSpentMins: 3,
        },
        {
          date: 1667534400000,
          totalTimeSpentMins: 6,
        },
        {
          date: 1670302800000,
          totalTimeSpentMins: 35.333333333333336,
        },
        {
          date: 1670389200000,
          totalTimeSpentMins: 4,
        },
      ],
    },
    {
      lessonsCompleted: 17,
      name: 'Keep Learning',
      id: 'keep',
      lessons: [
        {
          completionDates: ['2022-11-11T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-11T09:23:00.000Z',
          lastUsageDate: '2022-11-11T09:23:00.000Z',
          id: 'vocational-counseling',
          name: 'Vocational Counseling',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-11T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-11T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-11T09:23:00.000Z',
          lastUsageDate: '2022-11-11T09:23:00.000Z',
          id: 'financial-management',
          name: 'Financial Management',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/financial-management/worksheets/financial-management.pdf',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-11T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-11T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-11T09:23:00.000Z',
          lastUsageDate: '2022-11-11T09:23:00.000Z',
          id: 'insomnia',
          name: 'Insomnia',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/insomnia/worksheets/insomnia.pdf',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-11T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-11T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-11T09:23:00.000Z',
          lastUsageDate: '2022-11-11T09:23:00.000Z',
          id: 'time-management',
          name: 'Time Management',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/time-management/worksheets/time-management.pdf',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-11T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-17T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-17T09:23:00.000Z',
          lastUsageDate: '2022-11-17T09:23:00.000Z',
          id: 'introduction-to-relaxation-training',
          name: 'Introduction to Relaxation Training',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-17T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-17T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-17T09:23:00.000Z',
          lastUsageDate: '2022-11-17T09:23:00.000Z',
          id: 'progressive-muscle-relaxation-training',
          name: 'Progressive Muscle Relaxation Training',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/progressive-muscle-relaxation-training/worksheets/progressive-muscle-relaxation-training.pdf',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-17T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-17T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-17T09:23:00.000Z',
          lastUsageDate: '2022-11-17T09:23:00.000Z',
          id: 'progressive-muscle-relaxation-generalization-training',
          name: 'Progressive Muscle Relaxation Generalization Training',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/progressive-muscle-relaxation-generalization-training/worksheets/progressive-muscle-relaxation-generalization-training.pdf',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-17T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-17T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-17T09:23:00.000Z',
          lastUsageDate: '2022-11-17T09:23:00.000Z',
          id: 'introduction-to-anger-management',
          name: 'Introduction to Anger Management',
          totalTimeSpentMins: 3,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-17T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-23T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-23T09:23:00.000Z',
          lastUsageDate: '2022-11-24T09:23:00.000Z',
          id: 'how-to-become-more-aware-of-the-feeling-of-anger',
          name: 'How to Become More Aware of the Feeling of Anger',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/how-to-become-more-aware-of-the-feeling-of-anger/worksheets/how-to-become-more-aware-of-the-feeling-of-anger.pdf',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-24T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-23T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-23T09:23:00.000Z',
          lastUsageDate: '2022-11-24T09:23:00.000Z',
          id: 'coping-with-anger',
          name: 'Coping with Anger',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/coping-with-anger/worksheets/coping-with-anger.pdf',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-24T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-23T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-23T09:23:00.000Z',
          lastUsageDate: '2022-11-24T09:23:00.000Z',
          id: 'relationship-counseling-part-1',
          name: 'Relationship Counseling Part 1',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-24T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-23T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-23T09:23:00.000Z',
          lastUsageDate: '2022-11-24T09:23:00.000Z',
          id: 'relationship-counseling-part-2',
          name: 'Relationship Counseling Part 2',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-24T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-23T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-23T09:23:00.000Z',
          lastUsageDate: '2022-11-24T09:23:00.000Z',
          id: 'relationship-counseling-part-3',
          name: 'Relationship Counseling Part 3',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-24T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-23T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-23T09:23:00.000Z',
          lastUsageDate: '2022-11-24T09:23:00.000Z',
          id: 'hepatitis',
          name: 'Hepatitis',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-11-24T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-30T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-30T09:23:00.000Z',
          lastUsageDate: '2022-12-01T09:23:00.000Z',
          id: 'alcohol-use-and-risk-for-hiv-stis-and-hepatitis',
          name: 'Alcohol Use and Risk for HIV, STIs and Hepatitis',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-12-01T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-30T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-30T09:23:00.000Z',
          lastUsageDate: '2022-12-01T09:23:00.000Z',
          id: 'getting-tested-for-hiv-stis-and-hepatitis',
          name: 'Getting Tested for HIV, STIs, and Hepatitis',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-12-01T09:23:00.000Z'],
        },
        {
          completionDates: ['2022-11-30T09:23:00.000Z'],
          hasProficiency: true,
          lastCompletionDate: '2022-11-30T09:23:00.000Z',
          lastUsageDate: '2022-12-01T09:23:00.000Z',
          id: 'finding-more-hiv-sti-and-hepatitis-information',
          name: 'Finding More HIV, STI and Hepatitis Information',
          totalTimeSpentMins: 4,
          type: LessonProgressType.Completed,
          usageDates: ['2022-12-01T09:23:00.000Z'],
        },
        {
          hasProficiency: false,
          id: 'the-female-condom',
          name: 'The Female Condom',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          hasProficiency: false,
          id: 'negotiating-safer-sex',
          name: 'Negotiating Safer Sex',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          hasProficiency: false,
          id: 'taking-responsibility-for-choices',
          name: 'Taking Responsibility for Choices',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          hasProficiency: false,
          id: 'birth-control-and-hiv-and-stis',
          name: 'Birth Control and HIV and STIs',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          hasProficiency: false,
          id: 'living-with-hiv-communication-skills-for-disclosing-hiv-status',
          name: 'Living with HIV: Communication Skills for Disclosing HIV Status',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          hasProficiency: false,
          id: 'living-with-hiv-drug-use-and-the-immune-system',
          name: 'Living with HIV: Drug Use and the Immune System',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          hasProficiency: false,
          id: 'living-with-hiv-managing-treatment-and-medications',
          name: 'Living with HIV: Managing Treatment and Medications',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          hasProficiency: false,
          id: 'living-with-hiv-implementing-daily-routines-to-promote-health',
          name: 'Living with HIV: Implementing Daily Routines to Promote Health',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          hasProficiency: false,
          id: 'living-with-hepatitis-c-coping-skills',
          name: 'Living with Hepatitis C: Coping Skills',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          hasProficiency: false,
          id: 'living-with-hepatitis-c-managing-treatment-and-promoting-health',
          name: 'Living with Hepatitis C: Managing Treatment and Promoting Health',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          hasProficiency: false,
          id: 'naltrexone',
          name: 'Naltrexone',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          hasProficiency: false,
          id: 'limited-alcohol-use',
          name: 'Limited Alcohol Use',
          worksheetPath:
            'http://localhost:10825/clinical-content/en/limited-alcohol-use/worksheets/limited-alcohol-use.pdf',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
        {
          hasProficiency: false,
          id: 'alcohol-use-and-disulfiram-treatment',
          name: 'Alcohol Use and Disulfiram Treatment',
          totalTimeSpentMins: 0,
          type: LessonProgressType.Unlocked,
        },
      ],
      lessonsUseByDate: [
        {
          date: 1668142800000,
          totalTimeSpentMins: 16,
        },
        {
          date: 1668661200000,
          totalTimeSpentMins: 13,
        },
        {
          date: 1669266000000,
          totalTimeSpentMins: 24,
        },
        {
          date: 1669870800000,
          totalTimeSpentMins: 12,
        },
      ],
    },
  ],
  lastLessonUsageDate: '2022-12-07T08:00:00.000Z',
};
